import axios from 'axios'

const setAuthHeader = (config, token) => {
  const headers = config.headers || (config.headers = {});
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete headers['Authorization'];
  }
};

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
setAuthHeader(axios.defaults, localStorage.getItem('user_token'));
const service = axios.create({
  // baseURL: 'http://159.75.67.95:8045/api/',
  // baseURL: 'http://localhost:5005/api/',
  baseURL: 'https://api.nestspace.uk/api/',
  timeout: 1000 * 60 * 3
});

service.interceptors.request.use(function (config) {
  setAuthHeader(config, localStorage.getItem('user_token'));
  return config;
}, function (error) {
  return Promise.reject(error);
});

service.interceptors.response.use(res => {
  const responseData = res.data || {};
  const code = responseData.code || 200;
  const msg = responseData.message;
  if (code === 401) {
    localStorage.removeItem('user_token');
    console.warn('token过期');
    location.href = '/login';
    return Promise.reject(new Error(msg || 'Unauthorized'));
  }
  return responseData;
}, error => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('user_token');
    location.href = '/login';
  }
  return Promise.reject(error);
});



export default service
